"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Bookmark = _interopRequireDefault(require("@material-ui/icons/Bookmark"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _core = require("@material-ui/core");
var _styles = _interopRequireDefault(require("./styles"));
var _Auth = require("../../contexts/Auth");
var _Bookmarks = require("../../contexts/Bookmarks");
var _Bookmark2 = _interopRequireDefault(require("../../api/Bookmark"));
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function BookmarkItem(_ref) {
  var {
    bookmark,
    removeBookmark,
    pdf
  } = _ref;
  var classes = (0, _styles.default)();
  var [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  var matches = (0, _core.useMediaQuery)('(max-width:769px)');
  var {
    auth
  } = (0, _Auth.useAuth)();
  var trackService = (0, _Trackings.default)(auth);
  var handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  var handleClose = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };
  var handleItemClick = () => {
    if (matches) {
      window.history.back();
      return pdf.viewer.currentPageNumber = Number(bookmark.page_reference);
    }
    return pdf.viewer.currentPageNumber = Number(bookmark.page_reference);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    key: bookmark.id,
    onClick: handleItemClick,
    button: true
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    onClick: () => {
      trackService.trackChapterSelected({
        selectedChapter: bookmark.chapter_name
      });
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.chapterName
  }, bookmark.chapter_name))), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "settings",
    "aria-haspopup": "true",
    "aria-controls": "simple-menu",
    onClick: handleClick,
    className: classes.iconMenu
  }, /*#__PURE__*/_react.default.createElement(_MoreVert.default, {
    className: classes.icon
  })), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    id: "simple-menu-".concat(bookmark.id),
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PaperProps: {
      style: {
        marginTop: 47
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    onClick: event => {
      handleClose(event);
      removeBookmark();
    }
  }, "Excluir marca\xE7\xE3o"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.summaryContainer
  }, /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    key: bookmark.id,
    onClick: handleItemClick,
    button: true
  }, /*#__PURE__*/_react.default.createElement(_Bookmark.default, {
    className: classes.markIcon
  }), /*#__PURE__*/_react.default.createElement(_core.ListItemText, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.summary
  }, bookmark.summary)))), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }));
}
function BookmarksList(_ref2) {
  var {
    pdf
  } = _ref2;
  var classes = (0, _styles.default)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var {
    bookmarks,
    setBookmarks
  } = (0, _react.useContext)(_Bookmarks.BookmarksContext);
  function loadBookmarks() {
    var {
      applicationToken,
      sessionToken,
      uuid,
      userId
    } = auth;
    _Bookmark2.default.getAll(applicationToken, sessionToken, uuid, userId).then(response => setBookmarks(response.data));
  }
  var removeBookmark = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* () {
      var bookmarkToRemove = bookmarks.find(bookmark => bookmark.page_reference === String(pdf.viewer.currentPageNumber));
      yield _Bookmark2.default.remove(auth.applicationToken, auth.sessionToken, Number(bookmarkToRemove.id));
      loadBookmarks();
    });
    return function removeBookmark() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (bookmarks.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      className: classes.placeholder
    }, "Voc\xEA ainda n\xE3o marcou nenhuma p\xE1gina.");
  }
  return /*#__PURE__*/_react.default.createElement(_core.List, {
    component: "nav",
    className: classes.root
  }, bookmarks.sort((a, b) => a.id - b.id).map(bookmark => /*#__PURE__*/_react.default.createElement(BookmarkItem, {
    pdf: pdf,
    bookmark: bookmark,
    key: bookmark.id,
    removeBookmark: removeBookmark
  })));
}
BookmarkItem.propTypes = {
  bookmark: _propTypes.default.shape({
    chapter_name: _propTypes.default.string,
    summary: _propTypes.default.string,
    id: _propTypes.default.number.isRequired
  }).isRequired,
  pdf: _propTypes.default.object.isRequired,
  removeBookmark: _propTypes.default.func.isRequired
};
var _default = exports.default = BookmarksList;